import { createFileRoute } from '@tanstack/react-router';
import { OfficesPage } from '@/features/attendance/offices-page';
import { guardRoute } from '@/lib/route-guards';

/** `/hr/attendance/offices` (FR-ATT-2, attendance.manage): office locations for the geofence. */
export const Route = createFileRoute('/_app/hr/attendance_/offices')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/hr/attendance/offices');
  },
  component: OfficesPage,
});
